import { AbstractCommand } from 'src/models/command';

class CreateReceiverGroupCommand extends AbstractCommand {
	override readonly async = false;
	readonly name = 'IFS_Mail_Command_Command_CreateReceiverGroupCommand';

	public constructor(groupName: string) {
		super();
		this.parameters = {
			groupName: groupName,
		};
	}
}

export { CreateReceiverGroupCommand };
